import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapp = styled("div")(() => ({
  padding: "0 32px",
}))

export const Info = styled("div")(() => ({
  margin: "16px 0",
}))

export const Header = styled("div")(() => ({
  paddingBottom: 16,
  borderBottom: `1px solid ${palette.grey200}`,
  marginBottom: 16,
}))

export const Dialog = {
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          padding: "40px 16px",
        },
      },
    },
  },
}
